import React from 'react';

import { Badge } from '@lightspeed/flame/Badge/next';

import { createReactRenderer } from '../helpers/react-renderer';

interface Props {
  holdDays: number;
}

const URGENT_THRESHOLD_DAYS = 3;

const PreauthHoldDaysBadge: React.FC<Props> = ({ holdDays }) => {
  const variant = holdDays > URGENT_THRESHOLD_DAYS ? 'primary' : 'danger';
  const label = holdDays === 1 ? 'day' : 'days';

  return (
    <Badge variant={variant} data-automation="preauth-hold-days-badge">
      <var>{holdDays}</var>&nbsp;{label}
    </Badge>
  );
};

export const RenderedComponent = createReactRenderer({
  component: PreauthHoldDaysBadge,
  selector: '[data-react-root="PreauthHoldDaysBadge"]',
});

export default PreauthHoldDaysBadge;
